/**
 * Handles all event specific data
 */

import { combineReducers } from 'redux';
import eventActions from '../actions/events';
import availabilityReducer from './event/availability';
import connectionsReducer from './event/connections';
import directoryReducer from './event/directory';
import enrichmentsReducer from './event/enrichments';
import eventReducer from './event/event';
import exhibitorsReducer from './event/exhibitors';
import locationsReducer from './event/locations';
import meetingsReducer from './event/meetings';
import newsReducer from './event/news';
import notificationsReducer from './event/notifications';
import participantsReducer from './event/participants';
import questionsReducer from './event/questions';
import scheduleReducer from './event/schedule';
import speakersReducer from './event/speakers';
import userEventReducer from './event/userEvent';
import votingReducer from './event/voting';
import directoryTagsReducer from './event/directoryTags';
import directoryFilterReducer from './event/directoryFilter';
import leadsReducer from './event/leads';
import tagsReducer from './event/tags';

const reducers = {
    event: eventReducer,
    directory: directoryReducer,
    exhibitors: exhibitorsReducer,
    enrichments: enrichmentsReducer,
    locations: locationsReducer,
    leads: leadsReducer,
    meetings: meetingsReducer,
    news: newsReducer,
    participants: participantsReducer,
    schedule: scheduleReducer,
    questions: questionsReducer,
    speakers: speakersReducer,
    availability: availabilityReducer,
    connections: connectionsReducer,
    notifications: notificationsReducer,
    voting: votingReducer,
    userEvent: userEventReducer,
    directoryTags: directoryTagsReducer,
    directoryFilter: directoryFilterReducer,
    tags: tagsReducer,
};
const combinedEventReducers = combineReducers(reducers);

const stateDefaults = {
    userEventsLoaded: false,
    loadedEvents: [],
    parents: {},
    fetchTime: null,
};

export default function eventsCommonReducer(state, action) {
    if (!state) {
        state = Object.assign({}, stateDefaults);
    }

    switch (action.type) {
        case 'SESSION_LOGOUT':
            state = Object.assign({}, stateDefaults);
            break;
        case 'USER_EVENTS_LOADED':
            state = Object.assign({}, state, { userEventsLoaded: true, fetchTime: action.fetchTime });
        case 'EVENTS_UPDATE':
            state = Object.assign({}, state, {
                loadedEvents: _([...state.loadedEvents, ..._(action.events).map('id').value()])
                    .uniq()
                    .value(),
            });

            // Apply reducers to events
            _(action.events).each((event) => {
                state[event.id] = combinedEventReducers(state[event.id], eventActions.singleEventUpdate(event, action.fetchTime));
            });
            // Add extra flags to subEvents
            _(state.loadedEvents)
                .map((eventId) => state[eventId].event)
                .each((event) => {
                    if (state[event.id].event._isCommunity) {
                        _.each(state[event.id].event.subevents, (subEvent) => {
                            if (state[subEvent.id] && state[subEvent.id].event && !state[subEvent.id].event._isSubEvent) {
                                state[subEvent.id].event = Object.assign({}, state[subEvent.id].event, {
                                    _isSubEvent: true,
                                    _parentEventId: event.id,
                                });
                            }
                            state.parents[subEvent.id] = event.id;
                        });
                    }
                });
            break;
        case 'EVENT_CHANGE_PARTICIPANCE':
            {
                if (state[action.eventId]) {
                    state = {
                        ...state,
                        [action.eventId]: combinedEventReducers(state[action.eventId], action),
                    };
                }
                let parentEventId = state.parents[action.eventId];
                if (state.parents[action.eventId] && state[parentEventId]) {
                    state = {
                        ...state,
                        [parentEventId]: combinedEventReducers(state[parentEventId], action),
                    };
                }
            }
            break;
        case 'EVENTS_DELETE':
            state = { ...state, loadedEvents: state.loadedEvents.filter((id) => id != action.eventId) };
            delete state[action.eventId];
            break;
        case 'NOTIFICATIONS_RECEIVED':
            {
                state = { ...state };
                state.loadedEvents.forEach((eventId) => {
                    state[eventId] = {
                        ...state[eventId],
                        notifications: notificationsReducer(state[eventId].notifications, {
                            ...action,
                            eventId,
                            notifications: action.notifications.filter((n) => {
                                return _.get(n, 'content.data.eventId') == eventId;
                            }),
                        }),
                    };
                });
            }
            break;
        case 'SESSION_UPDATES':
            action.updates.events.forEach((eventUpdates) => {
                let eventId = eventUpdates.id;
                state = {
                    ...state,
                    [eventId]: combinedEventReducers(state[eventId], {
                        ...action,
                        eventId,
                        eventUpdates: eventUpdates,
                        updates: {
                            ...action.updates,
                            notifications: action.updates.notifications.filter((n) => _.get(n, 'content.data.eventId') == eventId),
                        },
                    }),
                };
            });
            break;
        // pass action to all events
        case 'UPDATE_USER':
            state = { ...state };
            for (let eventId of state.loadedEvents) {
                state[eventId] = combinedEventReducers(state[eventId], action);
            }
            break;
        //
        //
        //
        case 'SINGLE_EVENT_UPDATE':
            if (state.parents[action.eventId]) {
                let parentId = state.parents[action.eventId];
                if (state[parentId]) {
                    state = {
                        ...state,
                        [parentId]: combinedEventReducers(state[parentId], app.actions.events.subEventUpdate(action.event)),
                    };
                }
            }
        // don't break: continue with default
        default:
            if (action.eventId) {
                state = {
                    ...state,
                    [action.eventId]: combinedEventReducers(state[action.eventId], action),
                };
            }
    }

    return state;
}
